import { List, ModelBase, NeoModel } from "@singularsystems/neo-core";
import StaticExportFileSpecConfigurationLookup from "./StaticExportFileSpecConfigurationLookup";

@NeoModel
export default class StaticExportFileSpecPartialLookup extends ModelBase {

    public staticExportFileSpecId: number = 0;

    public exportName: string = "";

    public exportReportReference: string = "";

    public format: string = "";

    public isExpanded: boolean = false;

    public latestVersionOfFileSpecId: number | null = null;

    public staticExportFileSpecConfigurationLookups = new List(StaticExportFileSpecConfigurationLookup);
}